export default __webpack_public_path__ + "static/media/nike2.a70a7671.jpg";